export enum DriverChangesActionTypes {
    SET_DRIVER_CHANGES = "SET_DRIVER_CHANGES",
    CLEAR_DRIVER_CHANGES = "CLEAR_DRIVER_CHANGES"
}